var $ = global.jQuery = global.$;

var Slider = require('./Slider');

/**
 * Gallery slider widget. Extends Slider widget with some different widget options
 * @class
 * @extends Slider
 * @example <div data-widget="GallerySlider"></div>
 */

var GallerySlider = Slider.extend(
  /** @lends GallerySlider.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    this.$arrowContainer = this.$el.find('[data-slider-nav]');

    this.widgetOptions.responsive = false;
    this.widgetOptions.autoplay = false;
    this.widgetOptions.appendArrows = this.$arrowContainer;

    this._super();
  },
  /**
   * Updates the Slider counter (if there is one)
   */
  updateCounter: function(currentPage, totalPages, slick) {
    var caption = $(slick.$slides[slick.currentSlide]).find('.video-caption');
    if (caption.length) {
      this.$sliderCounter.html(caption.text());
    }
    else {
      this._super(currentPage, totalPages);
    }
    if (totalPages === 1) {
      this.$el.addClass('nav-disabled');
    } else {
      this.$el.removeClass('nav-disabled');
    }
  }
});

module.exports = GallerySlider;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/GallerySlider.js
// module id = 36
// module chunks = 0 1